/* eslint-disable @next/next/no-img-element */
"use client";

import { motion } from "framer-motion";
import { Users, Zap, Handshake } from "lucide-react";

const GuideTrustSection = () => {
  return (
    <section className="py-32 px-6 md:px-12 bg-white text-center text-[#0F172A]">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl judson-regular mb-6"
        >
          Be the guide your clients already trust.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-slate-600 text-lg max-w-3xl mx-auto mb-20"
        >
          AskLocal positions you as a tech-savvy, client-first professional by
          giving your clients a private concierge experience they won’t find
          anywhere else. You stay front and center, while AskLocal provides the
          structure, organization, and clarity behind the scenes.
          <br />
          <br />
          No competing platforms. No pay-to-play gimmicks. Just a better
          experience for everyone involved.
        </motion.p>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-10 mb-28">
          {[
            {
              title: "Virtual Local Storefront",
              desc: "Stand out in your market with a professional presence that builds credibility and trust.",
              icon: <Users className="w-9 h-9 text-[#4177BC] mx-auto mb-5" />,
            },
            {
              title: "Streamlined Client Onboarding",
              desc: "Bring clients into one organized system that keeps communication clear and efficient.",
              icon: <Zap className="w-9 h-9 text-[#EB9C2C] mx-auto mb-5" />,
            },
            {
              title: "Built-In Trust & Transparency",
              desc: "Deliver a smoother experience that drives confidence, retention, and referrals.",
              icon: <Handshake className="w-9 h-9 text-[#4177BC] mx-auto mb-5" />,
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.15, duration: 0.6 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl border border-gray-200 p-10 shadow-[0_10px_30px_rgba(15,23,42,0.08)] hover:shadow-[0_18px_45px_rgba(15,23,42,0.12)] transition-all duration-300"
            >
              {item.icon}
              <h3 className="text-2xl font-semibold mb-3 text-[#4177BC]">
                {item.title}
              </h3>
              <p className="text-slate-600 text-base leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Dashboard Screenshot */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <div className="max-w-6xl w-full">
            {/* Frame */}
            <div className="bg-white rounded-[26px] border border-gray-300 shadow-[0_40px_80px_rgba(15,23,42,0.18)] overflow-hidden">
              {/* Mac top bar */}
              <div className="flex items-center gap-2 px-4 py-3 border-b bg-[#F1F5F9]">
                <span className="w-3 h-3 rounded-full bg-red-400" />
                <span className="w-3 h-3 rounded-full bg-yellow-400" />
                <span className="w-3 h-3 rounded-full bg-green-400" />
              </div>

              {/* Full Screenshot (NO CROP) */}
              <img
                src="/asklocal-agent/dashboardImage.jpeg"
                alt="AskLocal Dashboard"
                className="w-full h-auto object-contain bg-white"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GuideTrustSection;
